module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Aristau-45e4f9dda7059ad5e9a26202cbae8d3c.svg";